













import Vue from 'vue';
import Siema from 'siema';
import * as Util from '@/util.ts';

export default Vue.extend({
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      siema: {},
      id: Util.generateId(),
    };
  },
  mounted() {
    const self: any = this;
    // TODO. Vue next tick doesn't cut it in this case. Maybe come up with a cleaner solution in the future.
    setTimeout(() => {
      if (!this.$props.images.length) {
        return;
      }
      const hasMoreThanOneImage = Boolean(this.$props.images.length > 1);
      self.$data.siema = new Siema({
        selector: `#id${this.$data.id}`,
        duration: 200,
        easing: 'ease-out',
        perPage: 1,
        startIndex: 0,
        draggable: hasMoreThanOneImage,
        multipleDrag: false,
        threshold: 20,
        loop: hasMoreThanOneImage,
        onInit: () => {
          return;
        },
        onChange: () => {
          return;
        },
      });
    }, 100);
  },
  methods: {
    siemaDotClick(index: number) {
      this.$data.siema.goTo(index);
    },
    initialize() {
      this.$forceUpdate();
    },
  },
});
